const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M40.174 4.888v14.667h-4.928V8.71h-7.634V4.888Zm-12.537 6.624h4.76v8.043h-4.76zm26.839-6.624-4.617 14.667h-5.084L48.189 8.71h-6.25V1.883h4.676v3.005zm9.973 14.667-4.184-7.454c-.35.036-.89.265-.89 1.25v6.204h-4.46v-5.29c0-2.332.986-4.364 3.764-4.7l-3.053-4.677h4.892l4.015 6.853c.65-.024.89-.613.89-2.067V4.888h4.568V9.48c0 2.861-1.491 4.099-3.98 4.412l3.57 5.662H64.45zM77.03 4.888v14.667h-5.025V4.888Zm7.569 0v14.667h-5.025V4.888Z",
    style: {
      fill: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.753.612S.4.612.4 3.964v16.07s0 3.354 3.352 3.354h16.07s3.353 0 3.353-3.354V3.964s0-3.352-3.352-3.352z",
    style: {
      fill: "#00aeef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.876 3.274h-4.972c-.703 0-.823.608-.823.608-.461 1.801-2.6 9.105-2.6 9.105-.215.567.39.567.39.567h4.97c.703 0 .824-.608.824-.608.46-1.802 2.6-9.106 2.6-9.106.215-.566-.39-.566-.39-.566m-3.478 12.263H8.426a.8.8 0 0 0-.824.608 98 98 0 0 1-1.122 3.941c-.215.567.39.567.39.567h4.972c.702 0 .823-.608.823-.608a101 101 0 0 1 1.12-3.942c.219-.566-.388-.566-.388-.566",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallaLogo);
export default __webpack_public_path__ + "static/media/walla-logo.a163037c3c33c201aa336f115cd82c30.svg";
export { ForwardRef as ReactComponent };